import React from "react";
import { Drawer, Box } from "@mui/material";
import { HEADER_TOP_WRAPPER_HEIGHT } from "../../../constants";
import { SmallChatBar } from "./SmallChatBar/small-chat-bar";
import { MainChatWindow } from "./MainChatWindow/mainChatWindow";
import { useChatStore } from "../../../store/chatStore";

// Constants for the persistent drawer
const WIDTH = 500;     // full width of the panel
const PEEK = 90;       // how much remains visible when closed (width of small chat bar content)
const HEIGHT = `calc(100% - ${HEADER_TOP_WRAPPER_HEIGHT} + 10px)`;    // fixed height

export const Chat = () => {
  // Use centralized chat store
  const { isChatOpen } = useChatStore();

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open
      PaperProps={{
        sx: (theme) => ({
          width: WIDTH,
          height: HEIGHT,
          position: "fixed",
          right: 0,
          bottom: 0,
          top: "auto",
          borderRadius: "20px 0 0 0",
          boxShadow: "0 1px 5px rgba(0, 0, 0, 0.3)",
          overflow: "visible",   // so the handle can protrude
          transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.standard,
          }),
          // slide out completely except for the peek amount
          transform: `translateX(${isChatOpen ? 0 : WIDTH - PEEK}px)`,
          zIndex: 1001, // Higher than FAB button (1000)
          // Mobile responsive behavior - align with project's secondBreakpoint (980px)
          '@media (max-width: 980px)': {
            width: '100%',
            height: '100%',
            borderRadius: '0 0 0 0',
            zIndex: 1001, // Higher than FAB button (1000)
            transform: `translateX(${isChatOpen ? 0 : '100%'})`,
          },
        }),
      }}
      hideBackdrop          // no modal backdrop (lets the rest be clickable)
    >
      {/* Handle that stays visible even when closed - this is our SmallChatBar */}
      <Box
      
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: PEEK,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          bgcolor: "background.paper",
          borderTopLeftRadius: "20px",
          borderBottomLeftRadius: "20px",
          zIndex: 1002, // Higher than chat drawer and FAB button
        }}
      >
        <SmallChatBar />
      </Box>

      {/* Panel content - this is our MainChatWindow */}
      <Box 
        sx={{ 
          height: '100%', 
          display: 'flex', 
          flexDirection: 'column',
          marginLeft: `${PEEK}px`, // Add left margin to prevent overlap with SmallChatBar
          width: `calc(100% - ${PEEK}px)`, // Adjust width to account for margin
        }}
      >
        <MainChatWindow />
      </Box>
    </Drawer>
  );
};


